function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { TimedMetadataType } from '../../core/player/player-engine-item';
import { sdkLogger } from '../../logger';
import { checkIsId3DataCue } from '../../utils/timed-metadata';
import { createBoundaryEventFromID3 } from './event-boundary';
import { filter, parse } from '@sky-uk-ott/core-video-sdk-js-external-txml/dist/txml';
import { decodeXmlEntities } from '../../utils/xml-utils';
export var ID3_EMSG_SCHEME_URI = 'https://aomedia.org/emsg/ID3';
var HARMONIC_PARENTAL_CONTROL_SCHEME_URI = 'urn:com:harmonicinc:parentalcontrol:id3:2017';
var SKY_PARENTAL_CONTROL_SCHEME_URI = 'urn:com:sky:inbandmetadata:2017';
// This type will allow us to check `isSleEndEvent` and use the value without typecasting
// TS doesn't support glob matching in type strings, this is just to represent that
// SLE End Event is different to regular Id3/Emsg events because the messageData contains "sle-end"
// messageData: `${string}sle-end${string}`; // This is a type-accurate definition but only supported in TS 4.1+
// messageData: `${string}sle-end${string}`; // This is a type-accurate definition but only supported in TS 4.1+
export var StreamMetadataParserAddon = /*#__PURE__*/ function() {
    "use strict";
    function StreamMetadataParserAddon(session) {
        var _this = this;
        _class_call_check(this, StreamMetadataParserAddon);
        _define_property(this, "session", void 0);
        _define_property(this, "name", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "endOfEventTimeFired", void 0);
        _define_property(this, "handleMetadata", void 0);
        this.session = session;
        this.name = 'StreamMetadataParser';
        this.endOfEventTimeFired = false;
        this.handleMetadata = function(metadata) {
            if (_this.checkIsSleEndEvent(metadata)) {
                _this.handleSleEndEvent(metadata);
            } else if (metadata.type === TimedMetadataType.Id3 || metadata.type === TimedMetadataType.EMsg && [
                HARMONIC_PARENTAL_CONTROL_SCHEME_URI,
                SKY_PARENTAL_CONTROL_SCHEME_URI
            ].includes(metadata.schemeIdUri)) {
                _this.handleId3Metadata(metadata);
            } else if (metadata.type === TimedMetadataType.DataCue) {
                _this.handleDataCue(metadata);
            }
        };
        this.session.onTimedMetadataReceived(this.handleMetadata);
        this.logger = sdkLogger.withContext('Metadata-parser');
    }
    _create_class(StreamMetadataParserAddon, [
        {
            key: "destroy",
            value: function destroy() {}
        },
        {
            key: "checkIsSleEndEvent",
            value: // TODO: add parsers for different timed metadata types
            function checkIsSleEndEvent(metadata) {
                var messageData;
                var presentationTime;
                if (metadata.type === TimedMetadataType.EMsg || metadata.type === TimedMetadataType.Id3) {
                    messageData = metadata.messageData;
                    presentationTime = metadata.presentationTime;
                } else if (checkIsId3DataCue(metadata)) {
                    messageData = metadata.data;
                    presentationTime = metadata.presentationTime;
                }
                // https://jira.inbcu.com/browse/PBSCVJS-646
                // In Safari browsers messageData is sometimes of type ArrayBuffer
                // sle-end only comes as a string so we can safely ignore messageData when that's not the case
                return Boolean(typeof messageData === 'string' && Boolean(messageData === null || messageData === void 0 ? void 0 : messageData.includes('sle-end')) && presentationTime !== undefined);
            }
        },
        {
            key: "handleId3Metadata",
            value: function handleId3Metadata(metadata) {
                var parsedMetadata = createBoundaryEventFromID3(metadata.messageData);
                if (parsedMetadata && parsedMetadata.currentEventData !== null) {
                    this.session.notifyStreamMetadataReceived(parsedMetadata.currentEventData);
                }
            }
        },
        {
            key: "handleDataCue",
            value: function handleDataCue(metadata) {
                if (checkIsId3DataCue(metadata) && metadata.data) {
                    this.handleId3Metadata({
                        messageData: String(metadata.data),
                        type: TimedMetadataType.Id3
                    });
                }
            }
        },
        {
            key: "handleSleEndEvent",
            value: function handleSleEndEvent(metadata) {
                if (this.endOfEventTimeFired) {
                    this.logger.verbose('Ignoring EMSG for SLE event end - already Fired');
                    return;
                }
                try {
                    var messageData = 'messageData' in metadata ? metadata.messageData : metadata.data;
                    var xmlString = messageData.substring(messageData.indexOf('<'));
                    var timeAdjustment = this.getSleEventEndTimeAdjustment(xmlString);
                    if (timeAdjustment === null) {
                        return;
                    }
                    // https://jira.inbcu.com/browse/PBSCVJS-452
                    // on Android player the metadata sometimes contains a string
                    // value for metadata.presentationTime - must be a Number
                    var presentationTime = Number(metadata.presentationTime);
                    var endOfEventTime = presentationTime + timeAdjustment;
                    this.endOfEventTimeFired = true;
                    this.session.notifyEndOfEventMarkerReceived(endOfEventTime);
                    this.logger.info("Notified SLE end of event as ".concat(endOfEventTime));
                } catch (e) {
                    this.logger.warn('Failed to parse EMSG for SLE event end: ', e);
                }
            }
        },
        {
            key: "getSleEventEndTimeAdjustment",
            value: function getSleEventEndTimeAdjustment(xmlString) {
                var xmlDoc = parse(xmlString);
                var pElements = filter(xmlDoc, function(node) {
                    return node.tagName === 'p';
                });
                if (!(pElements === null || pElements === void 0 ? void 0 : pElements.length)) {
                    this.logger.verbose('Received EMSG for SLE event end, without data');
                    return null;
                }
                var startTime = pElements[0].attributes['begin'].split(':').reverse().reduce(function(acc, num, idx) {
                    return acc + parseFloat(num) * Math.pow(60, idx);
                }, 0);
                var pText = filter(pElements[0].children, function(node) {
                    return node.tagName === 'span';
                })[0].children[0];
                var offset = JSON.parse("{".concat(decodeXmlEntities(pText), "}")).offset;
                return startTime - parseInt(offset, 10);
            }
        }
    ]);
    return StreamMetadataParserAddon;
}();

//# sourceMappingURL=stream-metadata-parser.js.map